export default function Hero() {
  return (
    <>
      {/* ===== 大主视觉压顶 · 本期杂志封面 ===== */}
      <section id="top" className="relative flex min-h-[600px] w-full items-center overflow-hidden md:min-h-[640px]">
        <div
          className="absolute inset-0 bg-cover bg-top object-cover"
          style={{
            backgroundImage:
              "url(https://readdy.ai/api/search-image?query=cinematic%20editorial%20magazine%20hero%20scene%20of%20newsprint%20pages%20and%20newspaper%20clippings%20floating%20in%20warm%20amber%20stage%20light%20with%20a%20spotlight%20beam%2C%20vintage%20reportage%20aesthetic%2C%20rich%20terracotta%20crimson%20and%20cream%20tones%2C%20deep%20soft%20shadows%2C%20high%20detail%20moody%20photography&width=1600&height=900&seq=hero-cover-01&orientation=landscape)",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/45 to-foreground-950/70" />

        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col items-center px-4 text-center md:px-6">
          <div className="animate-rise inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs font-medium text-white backdrop-blur">
            <span className="flex h-2 w-2 items-center justify-center">
              <i className="ri-fire-fill text-primary-300" />
            </span>
            本期封面 · 总第36辑 · 2026年9月刊
          </div>

          <h1 className="animate-rise-1 mt-7 max-w-4xl font-heading text-4xl font-black leading-[1.15] text-white drop-shadow-sm md:text-6xl">
            大瓜一台接一台，
            <br className="hidden md:block" />
            来龙去脉一次扒个通透
          </h1>

          <p className="animate-rise-2 mt-6 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
            黑料合集档案式全景盘点：从热搜炸开的那一秒，到当事人回应、品牌解约、舆论反转——我们把每一场大戏的时间线摊在桌上，
            吃瓜就要吃全套。
          </p>

          <div className="animate-rise-3 mt-9 flex flex-col items-center gap-3 sm:flex-row">
            <a
              href="#dangan"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              打开本期事件档案
              <span className="flex h-5 w-5 items-center justify-center">
                <i className="ri-book-open-line text-lg" />
              </span>
            </a>
            <a
              href="#kuaiti"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-6 py-3.5 text-sm font-bold text-white backdrop-blur transition-colors hover:bg-white/20 sm:w-auto"
            >
              先看今日快讯流
            </a>
          </div>

          <div className="animate-rise-3 mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/75">
            <span className="inline-flex items-center gap-1.5">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-time-line" />
              </span>
              每日新料更新
            </span>
            <span className="inline-flex items-center gap-1.5">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-stack-line" />
              </span>
              累计收录档案 1286
            </span>
            <span className="inline-flex items-center gap-1.5">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-focus-3-line" />
              </span>
              本栏目标签 39 个
            </span>
          </div>
        </div>

        <div className="absolute bottom-5 left-1/2 hidden -translate-x-1/2 flex-col items-center gap-1 text-white/60 md:flex">
          <span className="text-[11px] tracking-[0.3em]">SCROLL</span>
          <span className="flex h-5 w-5 items-center justify-center animate-bounce">
            <i className="ri-arrow-down-line text-base" />
          </span>
        </div>
      </section>

      {/* ===== 封面导读 · 本期目录 ===== */}
      <section className="relative border-b border-background-200 bg-background-100">
        <div className="mx-auto grid max-w-7xl gap-8 px-4 py-8 md:grid-cols-[1.2fr_1fr] md:gap-12 md:px-6 md:py-10">
          <div className="flex flex-col justify-center gap-3">
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.28em] text-primary-600 uppercase">
              <span className="h-px w-6 bg-primary-500" />
              编辑导读
            </span>
            <p className="font-heading text-xl font-bold leading-relaxed text-foreground-900 md:text-2xl">
              「本期我们把三件看似无关的大事连起来讲——
              <span className="text-primary-600">同一套舆论逻辑</span>
              ，换了个主角而已。」
            </p>
            <p className="text-sm leading-relaxed text-foreground-600">
              有人靠考古翻红，有人因一句话塌房。别急着站队，先把每一条时间线看完整，你会发现瓜田里的水，远比想象得深。
            </p>
          </div>

          <div className="flex flex-col justify-center divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
            {[
              { no: "01", t: "塌房全流程拆解", d: "从发酵到反转的四幕结构" },
              { no: "02", t: "营业话术观察", d: "官配背后的团队在忙什么" },
              { no: "03", t: "年度合集归档", d: "把一整年的瓜装订成册" },
            ].map((row) => (
              <a key={row.no} href="#dangan" className="group flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-100">
                <span className="font-display text-lg font-bold text-accent-600">{row.no}</span>
                <span className="flex-1">
                  <span className="block text-sm font-bold text-foreground-900 group-hover:text-primary-600">{row.t}</span>
                  <span className="block text-xs text-foreground-500">{row.d}</span>
                </span>
                <span className="flex h-8 w-8 items-center justify-center rounded-full border border-background-200 text-foreground-400 transition-all group-hover:border-primary-300 group-hover:text-primary-600">
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* ===== 实时快讯滚动条 ===== */}
      <div className="relative z-20 flex items-stretch overflow-hidden border-b border-background-200 bg-foreground-950">
        <div className="flex shrink-0 items-center gap-2 bg-primary-600 px-4 py-3 text-background-50">
          <span className="flex h-2 w-2 items-center justify-center">
            <i className="ri-radio-button-line animate-softpulse" />
          </span>
          <span className="whitespace-nowrap text-xs font-black tracking-wider">实时瓜田</span>
        </div>
        <div className="relative flex flex-1 items-center overflow-hidden">
          <div className="animate-ticker flex w-max items-center gap-10 whitespace-nowrap py-3 pl-6 text-sm text-white/85">
            {[0, 1].map((k) => (
              <span key={k} className="flex items-center gap-10">
                <span>综艺收官夜导演情绪失控提前离场，弹幕瞬间炸了</span>
                <span className="text-accent-500">◆</span>
                <span>新歌 demo 被泄，制作人深夜发长文回应</span>
                <span className="text-accent-500">◆</span>
                <span>隐婚三年被拍到同框，经纪人一句「尊重隐私」登顶</span>
                <span className="text-accent-500">◆</span>
                <span>考古现场又立功：一句旧玩笑成了全网新梗</span>
                <span className="text-accent-500">◆</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}